import { ARMOR_LABELS, ARMOR_TYPES, type ArmorType } from "@/shared/lib/armor";
import { cn } from "@/shared/lib/utils";
import { armorCounts } from "../splits.logic";
import type { BoardCharacter } from "../splits.types";

// Distinct per-armor badge colors — the documented raw-color exception: armor types have no
// semantic token and must read as four consistent, theme-independent categories.
const ARMOR_BADGE: Record<ArmorType, string> = {
  plate: "bg-zinc-500/15 text-zinc-300",
  mail: "bg-sky-500/15 text-sky-300",
  leather: "bg-amber-500/15 text-amber-300",
  cloth: "bg-violet-500/15 text-violet-300",
};

// Thin armor-count strip of colored badges: "P 2", "M 5", "L 9", "C 9".
// Counts main characters only, so the strip reflects main-character composition.
export function SplitSummary({ chars }: { chars: BoardCharacter[] }) {
  const counts = armorCounts(chars.filter((c) => c.isMain));
  return (
    <div className="grid grid-cols-4 gap-1 border-t border-border px-2.5 py-1.5">
      {ARMOR_TYPES.map((a) => (
        <span
          key={a}
          className={cn(
            "rounded px-1 py-0.5 text-center text-[10px] font-medium tabular-nums",
            ARMOR_BADGE[a],
          )}
        >
          {ARMOR_LABELS[a][0]}
          {counts[a]}
        </span>
      ))}
    </div>
  );
}
